import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { API_BASE_URL } from '../../config/api';
import './MobileOtherMessagesPage.css';

const MobileOtherMessagesPage = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [noticeDismissed, setNoticeDismissed] = useState(false);

  useEffect(() => {
    const fetchMessages = async () => {
      try {
        const token = localStorage.getItem('token');
        const res = await fetch(`${API_BASE_URL}/messages?type=other`, {
          headers: {
            'Content-Type': 'application/json',
            ...(token && { Authorization: `Bearer ${token}` }),
          },
        });
        if (res.ok) {
          const data = await res.json();
          setMessages(data.messages || data || []);
        }
      } catch (_) {
        setMessages([]);
      } finally {
        setLoading(false);
      }
    };
    fetchMessages();
  }, [user]);

  return (
    <div className="mom-page">
      {/* Header */}
      <div className="mom-header">
        <button className="mom-back-btn" onClick={() => navigate('/mobile/messenger')} aria-label="Back">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
            <polyline points="15 18 9 12 15 6" />
          </svg>
        </button>
        <h1 className="mom-title">Other messages</h1>
        <button className="mom-settings-btn" aria-label="Settings">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="3" />
            <path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-4 0v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83-2.83l.06-.06A1.65 1.65 0 004.68 15a1.65 1.65 0 00-1.51-1H3a2 2 0 010-4h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 012.83-2.83l.06.06A1.65 1.65 0 009 4.68a1.65 1.65 0 001-1.51V3a2 2 0 014 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 2.83l-.06.06A1.65 1.65 0 0019.4 9a1.65 1.65 0 001.51 1H21a2 2 0 010 4h-.09a1.65 1.65 0 00-1.51 1z" />
          </svg>
        </button>
      </div>

      {/* Push notification notice */}
      {!noticeDismissed && (
        <div className="mom-notice-bar">
          <div className="mom-notice-text">
            <strong>Stay in the know</strong>
            <span>Enable push notifications and never miss out on order updates and promotions. <button className="mom-enable-btn">Enable</button></span>
          </div>
          <button className="mom-notice-close" onClick={() => setNoticeDismissed(true)} aria-label="Dismiss">✕</button>
        </div>
      )}

      {/* Content */}
      <div className="mom-body">
        {loading ? (
          <div className="mom-loading">
            {[1, 2, 3].map(i => <div key={i} className="mom-skeleton" />)}
          </div>
        ) : messages.length === 0 ? (
          <div className="mom-empty">
            <div className="mom-empty-illustration">
              <svg viewBox="0 0 120 120" fill="none">
                <circle cx="60" cy="55" r="36" fill="#f5f5f5" />
                <ellipse cx="60" cy="95" rx="30" ry="8" fill="#f0f0f0" />
                <rect x="30" y="42" width="24" height="20" rx="6" fill="#ddd" />
                <rect x="66" y="42" width="24" height="20" rx="6" fill="#ddd" />
                <rect x="48" y="48" width="24" height="8" rx="3" fill="#ccc" />
                <circle cx="42" cy="52" r="10" fill="#e8e8e8" stroke="#ccc" strokeWidth="2" />
                <circle cx="78" cy="52" r="10" fill="#e8e8e8" stroke="#ccc" strokeWidth="2" />
                <circle cx="42" cy="52" r="5" fill="#d0d0d0" />
                <circle cx="78" cy="52" r="5" fill="#d0d0d0" />
                <circle cx="60" cy="78" r="6" fill="#ccc" />
                <path d="M46 95c0-8 6-14 14-14s14 6 14 14" fill="#ddd" />
                <circle cx="28" cy="70" r="8" fill="#ff6a00" opacity="0.7" />
                <ellipse cx="90" cy="68" rx="7" ry="10" fill="#ff6a00" opacity="0.7" />
              </svg>
            </div>
            <p className="mom-empty-label">No Items</p>
          </div>
        ) : (
          <div className="mom-list">
            {messages.map(msg => (
              <div key={msg.id} className="mom-msg-card">
                <div className="mom-msg-avatar">
                  {msg.avatar ? (
                    <img src={msg.avatar} alt={msg.senderName || 'User'} />
                  ) : (
                    <span>{(msg.senderName || 'U')[0]}</span>
                  )}
                </div>
                <div className="mom-msg-info">
                  <div className="mom-msg-name">{msg.senderName || msg.sender || 'Unknown'}</div>
                  <div className="mom-msg-preview">{msg.lastMessage || msg.content || ''}</div>
                </div>
                <div className="mom-msg-meta">
                  <span className="mom-msg-time">{msg.time || ''}</span>
                  {msg.unread > 0 && <span className="mom-msg-badge">{msg.unread}</span>}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default MobileOtherMessagesPage;
